import { ERequestStatus } from '../../types/requestStatus';
import { TAuthorArticlesState } from '../../types/authorArticles';
import {
  EGetAuthorArticlesActionType,
  EResetAuthorArticlesActionType,
  TAuthorArticlesActions,
} from '../../actions/authorArticles';

export const defaultState: TAuthorArticlesState = {
  meta: {
    limit: 0,
    offset: 0,
    total: 0,
  },
  status: ERequestStatus.Initial,
  items: [],
};

export const authorArticlesReducer = (state = defaultState, action: TAuthorArticlesActions) => {
  switch (action.type) {
    case EGetAuthorArticlesActionType.Loading:
      return { ...state, status: ERequestStatus.Loading };

    case EGetAuthorArticlesActionType.Succeed:
      return { ...state, ...action.payload, status: ERequestStatus.Succeed };

    case EGetAuthorArticlesActionType.AppendSucceed:
      return {
        ...state,
        meta: action.payload.meta,
        items: [...state.items, ...action.payload.items],
        status: ERequestStatus.Succeed,
      };

    case EGetAuthorArticlesActionType.Failed:
      return { ...state, status: ERequestStatus.Failed };

    case EResetAuthorArticlesActionType.Reset:
      return defaultState;

    default:
      return state;
  }
};
